//@ngInject
function routes($stateProvider, nsUtilProvider) {
  $stateProvider
    .state('dashboard-hub', {
      parent: 'root',
      url: '/dashboard',
      templateUrl: 'apps/dashboard-hub/templates/acp-dashboard-hub.ng.html',
      controller: 'AcpHubDashboardCtrl as vm',
      params: {
        startAddACardFlow: false
      },
      data: {
        permissions: {
          only: 'hub_user',
          redirectTo: {
            hub_user: 'dashboard'
          }
        }
      },
      resolve: {
        pageTitle: /* @ngInject */ function(module, $injector) {
          return $injector.invoke(
            nsUtilProvider.getPageTitle('apps/dashboard-hub')
          );
        },
        module: /* @ngInject */ function($ocLazyLoad) {
          return import(/* webpackChunkName: "acp.section.dashboard-hub" */ 'apps/dashboard-hub').then(
            $ocLazyLoad.loadModule
          );
        }
      }
    })
    .state('dashboard-hub.do-you-have-a-card-modal', {
      params: {
        startAddACardFlow: true
      }
    });
}

export default routes;
